import clsx from "clsx";
import { useEffect, useRef } from "react";
import { FaEraser } from "react-icons/fa";
// @ts-expect-error - The react-signature-canvas library is not typed
import SignatureCanvas from "react-signature-canvas";

const SignaturePad = ({
    onChange,
    error,
    value,
}: {
    onChange: (signatureImageBase64: string) => void;
    error?: string;
    value: string;
}) => {
    const signatureCanvas = useRef(null);

    useEffect(() => {
        if (value === "" && signatureCanvas.current) {
            // @ts-expect-error - The react-signature-canvas library is not typed
            signatureCanvas.current.clear();
        }
    }, [value]);

    // Pass base64 to parent when stroke ends
    const handleEnd = () => {
        if (onChange && signatureCanvas.current) {
            // @ts-expect-error - The react-signature-canvas library is not typed
            onChange(signatureCanvas.current.toDataURL());
        }
    };

    return (
        <div
            className={clsx("w-full border relative", {
                "border-red-500": error,
            })}
        >
            <SignatureCanvas
                ref={signatureCanvas}
                penColor="black"
                canvasProps={{
                    style: { width: "100%", height: "100px" }, // Syncing the canvas attributes with the CSS dimensions
                }}
                onEnd={handleEnd}
            />
            <button
                className="absolute px-4 py-2 rounded-tl-lg bg-gray-300 right-0 bottom-0"
                onClick={() => {
                    onChange("");
                }}
            >
                <FaEraser />
            </button>
        </div>
    );
};

export { SignaturePad };
